import { render, staticRenderFns } from "./remark.component.vue?vue&type=template&id=33ac6c03"
import script from "./remark.component.vue?vue&type=script&lang=js"
export * from "./remark.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports